import React from 'react';
import { PageProps } from '../types/page';
import PagesProvider, { ParsedQuery } from '../context/PagesProvider';
import { useRouter } from 'next/router';
import PageContent from './PageContent';
import { SchemeProvider } from '@osmosis/react-ui/context/SchemeContext';
import Scripts from '../app/_components/scripts/Scripts';
import Footer from './landing/FooterWrapper';

type Props = PageProps;

/**
 * Component with providers.
 */
const Page = (props: Props): JSX.Element => {
  const { showFooter = true, pathname, asPath, ...rest } = props;

  // Get legacy router
  const pagesRouter = useRouter();

  // Query used for both 'routerQuery' and 'routerParams' because
  // pages router doesn't have 'params' property, and both route and search params are
  // part of query object
  const query = (pagesRouter.query as ParsedQuery) || {};

  return (
    <>
      <Scripts asPath={asPath} pathname={pathname} user={props.user} />
      <PagesProvider
        routerPathname={pagesRouter.pathname}
        routerQuery={query}
        routerParams={query}
        routerPush={pagesRouter.push}
        routerBack={pagesRouter.back}
        asPath={pagesRouter.asPath}
        routerRefresh={pagesRouter.reload}
      >
        <SchemeProvider scheme={props.scheme || 'light'}>
          <PageContent isLoggedIn={!!props.user} {...props} />
        </SchemeProvider>
      </PagesProvider>

      {showFooter && <Footer isPagesRouter={true} {...rest} />}
    </>
  );
};

export default Page;
